import {socialButtonClick} from '../../../segment'

const lexstepFooterCtrl = (
  $scope,
  sharedProperties,
  socket,
  userService,
  $timeout
) => {
  socket.on('CANDIDATE_ASSIGNED_AGENT_UPDATE', async candidateId => {
    $timeout(async () => {
      if ($scope.user.id === candidateId) {
        $scope.user = await userService.refreshUser($scope.user)
        prepareFooter()
        $scope.$applyAsync()
      }
    }, 1500)
  })

  socket.on('CANDIDATE_PROFILE_AGENT_UPDATE', async candidateId => {
    $timeout(async () => {
      if ($scope.user.id === candidateId) {
        $scope.user = await userService.refreshUser($scope.user)
        prepareFooter()
        $scope.$applyAsync()
      }
    }, 1500)
  })

  const getContactDetailsForOthers = () => {
    let assignedAdmin = $scope.user.agent
    return getContactDetails(assignedAdmin, sharedProperties)
  }

  const setDefaultContactDetails = () => {
    angular.extend($scope, getDefaultContactDetails(sharedProperties))
  }

  const setAgentContactDetailsForOthers = () => {
    angular.extend($scope, getContactDetailsForOthers())
  }

  const prepareFooter = () => {
    if ($scope.user) {
      if (userHaveNoAgentAssign($scope)) setDefaultContactDetails()
      else setAgentContactDetailsForOthers()
    }
  }

  $scope.socialLinkClick = type => {
    socialButtonClick(type)
  }

  $scope.$on('user-load', prepareFooter)

  $scope.currentYear = new Date().getFullYear()
}

const userHaveNoAgentAssign = $scope => {
  let agent = $scope.user && $scope.user.agent
  return agent ? Object.keys(agent).length === 0 : true
}

export const getDefaultContactDetails = sharedProperties => {
  return {
    contactUsername: sharedProperties.getDefaultContactUsername(),
    contactEmail: sharedProperties.getDefaultContactEmail(),
    contactPhone: sharedProperties.getDefaultContactPhone(),
  }
}

const getContactDetails = (assignedAdmin, sharedProperties) => {
  return {
    contactUsername:
      (assignedAdmin.lastName && assignedAdmin.firstName
        ? assignedAdmin.firstName + ' ' + assignedAdmin.lastName
        : assignedAdmin.firstName) ||
      sharedProperties.getDefaultContactUsername(),
    contactEmail:
      assignedAdmin.email || sharedProperties.getDefaultContactEmail(),
    contactPhone:
      assignedAdmin.phone || sharedProperties.getDefaultContactPhone(),
  }
}

export {lexstepFooterCtrl}



// WEBPACK FOOTER //
// ./scripts/shared/directives/footer/footer.ctrl.js